<template lang="html">
  <section class=" row-start page">
    <rrss class="navidad"></rrss>
    <div class="container-intro">
      <carrousel></carrousel>
      <div class="intro-concurso">
        <div class="container-texto ">
          <img
          src="/static/img/concurso-navidad/esta-navidad.svg"
          alt="Esta navidad #seLleva"
          class="waypoints"
          data="fadeInUp"
          />
          <img
          src="/static/img/concurso-navidad/sorprender.svg"
          alt="sorprender con CARRETILLA"
          class="waypoints"
          data="fadeInUp"
          />
          <h2 class="waypoints" data="fadeInUp">
            Lo sentimos la promoción ha finalizado
          </h2>

        </div>

      </div>
    </div>





  </section>
  
</template>

<script lang="js">

  import rrss from '@/components/parts/rrss';
  import carrousel from '@/components/view-parts/carrousel';

  export default  {
    name: 'concurso-navidad',
    components: {
      'rrss' : rrss,
      'carrousel' : carrousel
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/css/styles-concurso.scss";
</style>



// WEBPACK FOOTER //
// src/components/views/fin-concurso-navidad.vue